export class Error {
  constructor(data = {}) {
    this.status = data.status_code;
    this.timestamp = data.timestamp;
    this.message = data.error_message;
    this.errors = data.errors;
    this.targetDto = data.target_dto;
  }
}
